import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from './auth.service';
import { EMPTY, catchError, filter, switchMap, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'oc-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormlyBootstrapModule, FormlyModule, RouterModule],
  template: `
    <div class="fullscreen-container primary-background d-flex">
      <div class="background background-1"></div>
      <div class="pane d-flex flex-column justify-content-center">
        <div class="pane-padding">
          <h1>Login</h1>
          <form [formGroup]="form" (ngSubmit)="onSubmit(model)">
            <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
            <a [routerLink]="['/forgotten-password']">Forgotten Password</a>
            <button type="submit" class="btn btn-primary w-100 mt-3 mb-4">
              <span *ngIf="loggingIn" class="spinner-border spinner-border-sm"></span>
              <span *ngIf="!loggingIn">Log In</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  `,
  styles: `
    h1 {
      margin-bottom: 1.75rem;
    }

    
  `,
})
export class LoginComponent {
  private auth = inject(AuthService);
  private router = inject(Router);
  private toastr = inject(ToastrService);

  loggingIn = false;
  form = new FormGroup({});
  model = { email: '', password: '' };

  options: FormlyFormOptions = {
    formState: {
      submitted: false,
    },
  };

  fields: FormlyFieldConfig[] = [
    {
      key: 'email',
      type: 'input',
      props: {
        label: 'Email',
        required: true,
        type: 'email',
        hideRequiredMarker: true,
      },
      validators: {
        validation: ['email'],
      },
    },
    {
      key: 'password',
      type: 'input',
      props: {
        label: 'Password',
        required: true,
        type: 'password',
        hideRequiredMarker: true,
      },
    },
  ];

  onSubmit(model: any) {
    this.options.formState.submitted = true;

    if (this.loggingIn) {
      return;
    }

    if (!this.form.valid) {
      this.toastr.error('Please review your login details and try again');
      return;
    }

    this.loggingIn = true;

    this.auth
      .login(model.email, model.password)
      .pipe(
        catchError((err) => {
          this.toastr.error(err.error.message);
          this.loggingIn = false;
          return EMPTY;
        }),
        switchMap(() => {
          return this.auth.auth$.pipe(filter((auth) => !!auth));
        }),
        tap(() => {
          this.router.navigate(['/']);
        }),
      )
      .subscribe();
  }
}
